import { render, staticRenderFns } from "./FTabsBorder.vue?vue&type=template&id=48de579c&"
import script from "./FTabsBorder.vue?vue&type=script&lang=js&"
export * from "./FTabsBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports